import React from 'react'
import styled from 'styled-components'
import invert from 'invert-color'
import Flip from 'react-reveal/Flip'

const Wrapper = styled.div`
  @import url('https://fonts.googleapis.com/css?family=PT+Sans+Caption:400,700');
  
  font-family: 'PT Sans Caption', sans-serif;
	display: flex;
	padding-top: 1rem;
	justify-content: center;
`

const Card = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;
	width: 90%;
	background-color: ${props => props.backgroundColor};
	padding: 1rem;
	border-radius: 5px;
  color: ${props => props.color};
`

const Header = styled.h1`
  margin: 2rem 0;
`

const Subheader = styled.h2`
  margin: 2rem 0;
  font-size: 2rem;
`

const Text = styled.p`
  margin: 2rem 0;
  white-space: pre-wrap;
`

const Button = styled.a.attrs({
  target: '_blank'
})`
  color: ${props => props.color};
  margin: 2rem 0 1rem 0;
  border-radius: 5px;
  border: solid 3px ${props => props.borderColor};
	background-color: transparent;
  font-size: 1.5rem;
  padding: 5px 20px;
  text-transform: uppercase;
  text-decoration: none;
`

const Box = styled.div`
  color: ${props => props.color};
  background-color: ${props => props.backgroundColor};
  min-height: 3rem;
  border-radius: 5px;
  padding: 0 1rem;
`

const QuickOffer = ({header, subheader, text, buttonText, link, primaryColor, secondaryColor, primaryTextColor, secondaryTextColor}) => {
  const textPrimaryColor = primaryTextColor || invert(primaryColor, true)
  const textSecondaryColor = secondaryTextColor || invert(secondaryColor, true)

  return (
    <Flip left ssrReveal>
      <Wrapper>
        <Card color={textPrimaryColor} backgroundColor={primaryColor}>

          <Box backgroundColor={secondaryColor} />
          <Header>{header}</Header>

          <Box backgroundColor={secondaryColor} />
          <Subheader>{subheader}</Subheader>

          <Box color={textSecondaryColor} backgroundColor={secondaryColor}>
            <Text>{text}</Text>
          </Box>

          <Button color={textPrimaryColor} borderColor={textPrimaryColor} href={link}>{buttonText}</Button>

        </Card>
      </Wrapper>
    </Flip>
  )
}

export default QuickOffer